import { TradesmanReg } from "./TradesmanReg";
import "./styles.scss";

export default { TradesmanReg };
